/**
 * A message rendered in the chat is identified by the message id issued by the backend
 * (`x-ai-message-id` / `x-human-message-id`). That id is the only value the feedback
 * endpoints (vote / comment / feedback) accept.
 *
 * When those headers are not available the UI still needs a stable React key to render and
 * update the streaming message, so a local placeholder id is used. Local placeholder ids are
 * prefixed so they can never be mistaken for a backend message id and sent to the API.
 */
const LOCAL_MESSAGE_ID_PREFIX = 'local-message:';

export const createLocalMessageId = () => `${LOCAL_MESSAGE_ID_PREFIX}${crypto.randomUUID()}`;

export const isServerMessageId = (messageId?: string): messageId is string =>
    !!messageId && !messageId.startsWith(LOCAL_MESSAGE_ID_PREFIX);
